import React from 'react'
import { Container, Row, Col } from 'reactstrap';
import Property from '@episerver/spa-core/Components/Property';
import { isBrowser, isMobile } from "react-device-detect";
import './SelfCareActions.scss';

// actions: [{ ActionName, ActionUrl, ActionIcon, ActionServices }]
// userServices: string[]

export default function SelfCareActions ({ context, iContent }) {
    return (
        <Container className="self-care-actions">     
            <Row className="rowOptions">
                <div className="purpleBorder"></div>
                <Property context={context} iContent={iContent} field="selfCareActionsArea" />
                {isBrowser ? <Property style={{position: 'absolute', left: '0'}} context={context} iContent={iContent} field="plusArea" /> : null }
            </Row>
        </Container>
    )
}



